import {useContext} from 'react';
import { AlertContext } from '../App';
import '../css/alert.css';
import AlertIcon from '../img/icon/alerticon.png';
function Alert() {
    const {showAlert, setShowAlert, errorMessage} = useContext(AlertContext);
    return (
        <div style={{ display: showAlert ? 'flex' : 'none' }} className="formAlert">
            <div className="formAlertContent">
                <div className="alert-header">
                    <img className="logo" src={AlertIcon} />
                </div>
                <div className="alert-body">
                    <h1>Warning</h1>
                    <span>{errorMessage}</span>
                </div>
                <div className="alert-footer">
                    <button type="button" onClick={(e) => setShowAlert(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                        ກັບຄືນ
                    </button>
                </div>
            </div>
        </div>
    )
}
export default Alert;
